import { createFileRoute, redirect } from '@tanstack/react-router'

import { dialogPath } from '~/lib/dialogs'

/**
 * The address a template's page wears while it is open. It is a mask over the page underneath,
 * which is where the router actually is — see `specs/tech.spec.md`. This route is what catches
 * the address arriving on its own: a link somebody shared, a bookmark, a reload with the masked
 * state gone. There is no page underneath to open over then, so it opens over the timeline, and
 * keeps the address it was asked for.
 */
export const Route = createFileRoute('/templates_/$templateId')({
  beforeLoad: ({ params }) => {
    // "new" is not a template anybody can have a page about — it is the way into writing one.
    if (params.templateId === 'new') {
      redirect({ to: '/templates/$templateId/edit', params: { templateId: 'new' }, throw: true })
    }
    redirect({
      to: '/',
      search: { dialog: 'template', template: params.templateId },
      throw: true,
      mask: { to: dialogPath('template', params.templateId) },
    })
  },
})
